import React from 'react';
import { profile } from '../data/resume.js';
import { GitHubIcon, LinkedInIcon, MailIcon } from './Icons.js';

const Footer = () => (
    <footer className="site-footer">
        <div className="container footer-inner">
            <p>© {new Date().getFullYear()} {profile.name}</p>
            <div className="footer-links">
                <a href={`mailto:${profile.email}`} aria-label="Email"><MailIcon /></a>
                <a href={profile.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub"><GitHubIcon /></a>
                <a href={profile.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedInIcon /></a>
            </div>
        </div>
    </footer>
);

export default Footer;
